import { createSlice } from "@reduxjs/toolkit";
import { OpenFormatState } from "../../models/OpenFormat.model";
import { exportOpenFormatFiles, exportAndDownloadOpenFormatFiles, getOpenFormatSummary } from "../thunks/openFormatThunks";
import { RootState } from "../store";

export { exportOpenFormatFiles, exportAndDownloadOpenFormatFiles, getOpenFormatSummary };

const initialState: OpenFormatState = {
  loading: false,
  error: null,
  success: false,
  lastDownloadedFile: null,
  summary: null,
  summaryLoading: false,
  summaryError: null,
};

const openFormatSlice = createSlice({
  name: "openFormat",
  initialState,
  reducers: {
    clearOpenFormatError: (state) => {
      state.error = null;
    },
    resetOpenFormatExportState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.lastDownloadedFile = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(exportOpenFormatFiles.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(exportOpenFormatFiles.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.success = true;
        state.lastDownloadedFile = action.payload.fileName;
      })
      .addCase(exportOpenFormatFiles.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "שגיאה בייצוא קבצי פורמט אחיד";
      })
      .addCase(exportAndDownloadOpenFormatFiles.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(exportAndDownloadOpenFormatFiles.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.success = true;
        state.lastDownloadedFile = action.payload;
      })
      .addCase(exportAndDownloadOpenFormatFiles.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "שגיאה בהורדת קבצי פורמט אחיד";
      })
      .addCase(getOpenFormatSummary.pending, (state) => {
        state.summaryLoading = true;
        state.summaryError = null;
      })
      .addCase(getOpenFormatSummary.fulfilled, (state, action) => {
        state.summaryLoading = false;
        state.summary = action.payload.summary;
      })
      .addCase(getOpenFormatSummary.rejected, (state, action) => {
        state.summaryLoading = false;
        state.summaryError = action.payload || "שגיאה בטעינת סיכום";
      });
  },
});

export const { clearOpenFormatError, resetOpenFormatExportState } =
  openFormatSlice.actions;

export const selectOpenFormatState = (state: RootState) => state.openFormat;
export const selectOpenFormatLoading = (state: RootState) =>
  state.openFormat.loading;
export const selectOpenFormatError = (state: RootState) =>
  state.openFormat.error;
export const selectOpenFormatSuccess = (state: RootState) =>
  state.openFormat.success;
export const selectOpenFormatLastDownloadedFile = (state: RootState) =>
  state.openFormat.lastDownloadedFile;
export const selectOpenFormatSummary = (state: RootState) =>
  state.openFormat.summary;
export const selectOpenFormatSummaryLoading = (state: RootState) =>
  state.openFormat.summaryLoading;
export const selectOpenFormatSummaryError = (state: RootState) =>
  state.openFormat.summaryError;

export default openFormatSlice.reducer;
